export const canvasContextOptions: CanvasRenderingContext2DSettings = {
  willReadFrequently: true,
};  